import { configureStore } from "@reduxjs/toolkit";

import { authReducer, tokenMiddleware } from "../features/authentication/services";
import { websiteDemoApiSlice } from "../features/botSettings/web/services/websiteUrlApiSlice";
import { langReducer } from "../features/langs/services";
import { apiSlice, rtkQueryErrorMiddleware } from "./api/apiSlice";
import { n8nApiSlice } from "./api/n8nApiSlice";
import { s3ApiSlice } from "./api/s3ApiSlice";
import { listenerMiddleware } from "./middlewares/listenerMidderwares";

const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        [n8nApiSlice.reducerPath]: n8nApiSlice.reducer,
        [s3ApiSlice.reducerPath]: s3ApiSlice.reducer,
        [websiteDemoApiSlice.reducerPath]: websiteDemoApiSlice.reducer,
        auth: authReducer,
        lang: langReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            apiSlice.middleware,
            tokenMiddleware,
            rtkQueryErrorMiddleware,
            listenerMiddleware.middleware,
            n8nApiSlice.middleware,
            s3ApiSlice.middleware,
            websiteDemoApiSlice.middleware
        ),
    devTools: process.env.NODE_ENV === "development", // should false for staging and prod
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
